import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconInfoComponent } from "./med-icon-info.component";

@NgModule({
  declarations: [
    MedIconInfoComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconInfoComponent,
  ],
})
export class MedIconInfoModule { }
